import React from 'react';

import { ReactNode } from 'react';

export const Show = ({
  show = false,
  when = false,
  children
}: ShowProps) => (
  (show || when) ? <>{children}</> : null
);


interface ShowProps {
  show?: boolean;
  when?: boolean;
  children: ReactNode;
}